import React from 'react'
import { Menu } from 'react-feather'
import { HeaderMenu } from './header-menu';
import { AuthButton } from './header-auth-button';
import { ProfileProvider } from './profile-hook';

const HeaderNavMobile = () => {
  const [toggled, setToggled] = React.useState(false)

  return (
    <div className="flex items-center header-nav-mobile">
      <ProfileProvider>
        <AuthButton small={true}/>
      </ProfileProvider>
      <Menu className="ml-5" onClick={() => setToggled(true)}/>
      {
        toggled &&
        <HeaderMenu setToggled={setToggled}/>
      }
    </div>
  )
}

export { HeaderNavMobile }
